<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="proformas" [lazy]="false" dataKey="proformaId"
  selectionMode="single" [(selection)]="proforma" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  [paginator]="showPagination" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h2 style="float: left;margin: 6px;">Proformas</h2>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}">Tags</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'proformaId', 'in')"></th> -->
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:70px;" type="text"
      (input)="pt.filter($event.target.value, 'propertyCode', 'in')"></th> -->
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'name', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th>
        <!-- <input pInputText style="width:70px;" type="text"
        (input)="pt.filter($event.target.value, 'preparedDate', 'in')"> -->
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'CreateByUserVO.firstName', 'in')"></th>
      <th><p-multiSelect [options]="statuses" displaySelectedLabel
      optionLabel="name" appendTo="body" (onChange)="pt.filter($event.value, 'status', 'in')"></p-multiSelect></th>
      <th><p-multiSelect [options]="visibilities" displaySelectedLabel
      optionLabel="name" appendTo="body" (onChange)="pt.filter($event.value, 'visibility', 'in')"></p-multiSelect></th>
      <th><input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'RealtorProfileVO.firstName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'OwnerProfileLeadVO.firstName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"><app-tag-join-filter-select [tagSource]="70" (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <!-- <th [ngStyle]="{'width': 'auto'}"></th> -->
    </tr>
  }
</ng-template>

<ng-template pTemplate="body" let-proforma>
  <tr [pSelectableRow]="proforma">
    <td>{{proforma.name}}</td>
    <td>{{proforma.customAddress}}</td>
    <td>{{proforma.preparedDate | date:'MM-dd-yyyy'}}</td>
    <td>{{proforma?.createByProfile?.firstName}}</td>
    <td>{{getStatusName(proforma)}}</td>
    <td>{{getVisibilityName(proforma)}}</td>
    <td>{{proforma?.realtorProfile?.firstName}}</td>
    <td>{{proforma?.ownerLeadProfile?.firstName}}</td>
    <td>{{proforma.expandYrGrossTtl | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
    <td>{{proforma.stableYrGrossTtl | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
    <td>{{proforma.contractYrGrossTtl | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
    <app-tag-join-list-select [tagSource]="70" [tagSourceId]="proforma.proformaId" tagType="4"></app-tag-join-list-select>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(proforma)"></i>
      </a>
    </span>
  </td>
</tr>
</ng-template>
</p-table>